import { CustomEnumMode, CustomParamScenario, CustomEnumType, CustomEnumValue } from './model';
import { fetchApi } from './common';

// 获取自定义枚举类型列表
export async function listCustomEnumTypes(scenario?: CustomParamScenario) {
  return fetchApi<CustomEnumType[]>('/api/doctor_view/custom_enum_types', 'GET', {
    scenario
  });
}

// 设置自定义枚举类型启用状态
export async function setCustomEnumTypeEnabled(id: string, isEnabled: boolean) {
  return fetchApi<CustomEnumType>(`/api/doctor_view/custom_enum_types/${id}/set_enabled`, 'PUT', {
    is_enabled: isEnabled
  });
}

// 设置自定义枚举值启用状态
export async function setCustomEnumValueEnabled(id: string, isEnabled: boolean) {
  return fetchApi<CustomEnumValue>(`/api/doctor_view/custom_enum_values/${id}/set_enabled`, 'PUT', {
    is_enabled: isEnabled
  });
}

// 创建自定义枚举类型
export async function createCustomEnumType(
  name: string,
  scenarios: CustomParamScenario[],
  mode: CustomEnumMode,
  isEnabled: boolean = true
) {
  return fetchApi<CustomEnumType>('/api/doctor_view/custom_enum_types', 'POST', {
    name,
    scenarios,
    mode,
    is_enabled: isEnabled
  });
}

// 更新自定义枚举类型
export async function updateCustomEnumType(
  id: string,
  name?: string,
  scenarios?: CustomParamScenario[],
) {
  return fetchApi<CustomEnumType>(`/api/doctor_view/custom_enum_types/${id}`, 'PUT', {
    name,
    scenarios,
  });
}

// 获取自定义枚举值列表
export async function listCustomEnumValues(typeId: string) {
  return fetchApi<CustomEnumValue[]>(`/api/doctor_view/custom_enum_values?type_id=${typeId}`, 'GET');
}

// 创建自定义枚举值
export async function createCustomEnumValue(
  typeId: string,
  name: string,
  description?: string
) {
  return fetchApi<CustomEnumValue>('/api/doctor_view/custom_enum_values', 'POST', {
    type_id: typeId,
    name,
    description
  });
}

// 更新自定义枚举值
export async function updateCustomEnumValue(
  id: string,
  name?: string,
  description?: string
) {
  return fetchApi<CustomEnumValue>(`/api/doctor_view/custom_enum_values/${id}`, 'PUT', {
    name,
    description
  });
}